// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item::part(native) {
  background: #47475d;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  border-color: var(--ion-color-secondary);
  border-width: 1px;
  border-radius: 8px;
}

ion-item::part(native):hover {
  background: #1b1b24;
}

ion-thumbnail {
  --size: 64px;
  --border-radius: 4px;
}

ion-icon {
  cursor: pointer;
}

ion-icon[name=extension-puzzle] {
  font-size: 2.5rem;
  margin: 10px;
}

h5 {
  color: var(--ion-color-light);
  font-size: 15px;
}

p {
  color: var(--ion-color-medium);
  font-size: 12px;
  font-weight: 500;
}

ion-item.selected::part(native) {
  background: #1b1b24;
}`, "",{"version":3,"sources":["webpack://./src/app/components/live-dealer-lobby/live-dealer-tile/live-dealer-tile.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,2CAAA;EACA,4BAAA;EAEA,wCAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,eAAA;AAAJ;;AAGA;EACI,8BAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ","sourcesContent":["ion-item::part(native) {\r\n    background: #47475d;\r\n    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\r\n    transition: all 0.3s ease 0s;\r\n\r\n    border-color: var(--ion-color-secondary);\r\n    border-width: 1px;\r\n    border-radius: 8px;\r\n}\r\n\r\nion-item::part(native):hover {\r\n    background: #1b1b24;\r\n}\r\n\r\nion-thumbnail {\r\n    --size: 64px;\r\n    --border-radius: 4px;\r\n}\r\n\r\nion-icon {\r\n    cursor: pointer;\r\n}\r\n\r\nion-icon[name='extension-puzzle']{\r\n    font-size: 2.5rem;\r\n    margin: 10px;\r\n}\r\n\r\nh5 {\r\n    color: var(--ion-color-light);\r\n    font-size: 15px;\r\n}\r\n\r\np {\r\n    color: var(--ion-color-medium);\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\nion-item.selected::part(native) {\r\n    background: #1b1b24;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
